import React from 'react';
import ContactSupportLink from '../../../components/ContactSupportLink';
import { PricingPage, Product } from '../../../types/pricingPage';

interface Props {
    allProducts: Product[];
    status: PricingPage['status'];
    onChangeMode: (status: PricingPage['status']) => void;
}

export default function ProductsHint({ allProducts, status, onChangeMode }: Props) {
    const handleSwitchToLive = () => {
        onChangeMode('ACTIVE');
    };

    return (
        <>
            {!!allProducts && (
                <div className="justify-self-center text-center text-sm p-4 hidden md:block">
                    {allProducts?.length > 0 && <span className="font-bold">Something missing? </span>}

                    <ul className="text-left list-disc p-4">
                        <li>
                            <a
                                href="https://stripe.com/docs/api/products"
                                target="_blank"
                                rel="noreferrer"
                                className="underline"
                            >
                                Products
                            </a>{' '}
                            are pulled directly from your Stripe account.
                        </li>
                        <li>
                            Check that your products are configured in{' '}
                            <strong>{status === 'ACTIVE' ? 'live' : 'test'}</strong> mode
                            {status === 'ACTIVE' ? '' : ', not live mode'}. You can switch modes above.
                        </li>
                        <li>Products must have a price configured.</li>
                        <li>
                            Support for Tiered pricing is in Beta. Please <ContactSupportLink /> for issues.
                        </li>
                        {status === 'DRAFT' && (
                            <li>
                                Using Stripe <span className="font-semibold">Test</span> Mode -
                                <button onClick={handleSwitchToLive} className="underline ml-2">
                                    Switch to Live mode
                                </button>
                            </li>
                        )}
                        <li>
                            You can{' '}
                            <a
                                href="https://dashboard.stripe.com/products"
                                target="_blank"
                                rel="noreferrer"
                                className="link"
                            >
                                create new products in Stripe
                            </a>
                            .
                        </li>
                    </ul>
                </div>
            )}

            {!allProducts && (
                <div className="text-center">
                    <a
                        href="https://dashboard.stripe.com/products"
                        target="_blank"
                        rel="noreferrer"
                        className="bg-gray-700 text-white font-semibold p-2 mt-5 rounded shadow-lg hover:shadow-xl hover:bg-gray-300 hover:text-black"
                    >
                        Create Products in Stripe
                    </a>
                </div>
            )}
        </>
    );
}
